import React from 'react'
import classnames from 'classnames'

import { list, listItem } from './List.module.scss'

const List = ({ items, columns = 1, large, className, ...props }) => {
  return (
    <ul
      className={classnames(
        list,
        `columns-${columns}`,
        large && 'large',
        className
      )}
      {...props}
    >
      {items.map((item, idx) => {
        return (
          <li key={idx} className={listItem}>
            {item}
          </li>
        )
      })}
    </ul>
  )
}

export default List
